<template>
  <div>
    <div class="vx-col w-full mb-base">
      <vs-card title="Add New Customer" class="p-4 mb-6">
        <div slot="header" class="flex flex-wrap items-center justify-between">
           <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
              <h4>Resend AWB</h4>
          </div>
            <div class="flex flex-wrap items-center justify-between ag-grid-table-actions-right">
            <vs-button color="primary" class="btn mb-4 md:mb-0 mr-1" @click="submitForm">Process</vs-button>
           
            </div>
        </div>
        <div class="vx-row mt-6">
          <div class="vx-col md:w-1/4 w-full">

              <label class="vs-input--label">No Reference</label>
                <vs-input class="w-full" v-model="reference" />

          </div>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
  data() {
    return {
      isLoading: false,
      isForm: false,
      file:null,
      reference:"",
    };
  },
  watch: {
    isLoading: function() {
      if (this.isLoading) {
        this.$vs.loading();
      } else {
        this.$vs.loading.close();
      }
    }
  },
  methods: {
    submitForm() {
      if(this.reference == ''){
        this.$vs.notify({
              color: "danger",
              title: "Error",
              text: "No Reference is required"
          });

          return false;
      }
      this.isLoading = true;
      this.$http.post("support/resend_awb_confirm_status", {
          reference: this.reference
      })
      .then(res => {
          this.isLoading = false;
          const message = res.data.message ? res.data.message : 'Success.'
          this.$vs.notify({
              color: "success",
              title: "Success",
              iconPack: "feather",
              icon: "icon-check",
              text: message
          });
          
          setTimeout(() => {
              window.location.reload()
          }, 200);
      })
      .catch(error => this.handleError(error));
    },
  },
  mounted() {
  }
};
</script>